// ------------------SAGA-------------------------
export const USER_SIGNIN_API = "USER_SIGNIN_API";

export const USER_SIGNUP_API = "USER_SIGNUP_API";

// -----------------Action---------------------------
export const USER_LOGIN_ACTION = "USER_LOGIN_ACTION ";

export const USER_REGISTER_ACTION = "USER_REGISTER_ACTION"